import * as actionTypes from './types';

const contextActions = (dispatch) => {
  return {
    sidenav: {
      open: () => dispatch({ type: actionTypes.OPEN_SIDENAV, value: true }),
      close: () => dispatch({ type: actionTypes.OPEN_SIDENAV, value: false }),
      setType: (type) => dispatch({ type: actionTypes.SIDENAV_TYPE, value: type }),
      setColor: (color) => dispatch({ type: actionTypes.SIDENAV_COLOR, value: color }),
    },
    navbar: {
      setTransparent: (isTransparent) => dispatch({ type: actionTypes.TRANSPARENT_NAVBAR, value: isTransparent }),
      setFixed: (isFixed) => dispatch({ type: actionTypes.FIXED_NAVBAR, value: isFixed }),
    },
    configurator: {
      open: () => dispatch({ type: actionTypes.OPEN_CONFIGURATOR, value: true }),
      close: () => dispatch({ type: actionTypes.OPEN_CONFIGURATOR, value: false }),
    },
    chat: {
      open: () => dispatch({ type: actionTypes.OPEN_CHAT, value: true }),
      close: () => dispatch({ type: actionTypes.OPEN_CHAT, value: false }),
    },
    app: {
      open: () => dispatch({ type: actionTypes.OPEN_SIDENAV, value: true }),
      default: () => console.log("Reset to default state or perform some other action"),
    },
    dashboard:{
      open: () => dispatch({ type: actionTypes.OPEN_SIDENAV, value: true }),
    }
  };
};

export default contextActions;
